import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setErr(res.error);
  };

  const input = "w-full bg-neutral-50 border border-neutral-200 rounded-xl px-4 py-3 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-brand-500";

  return (
    <main className="min-h-screen flex items-center justify-center px-4 pt-28 pb-12 bg-ink">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-surface border border-neutral-200 shadow-card rounded-3xl p-8">
        <h1 className="font-display text-3xl font-bold text-neutral-900 mb-1">Welcome back</h1>
        <p className="text-neutral-500 mb-6">Log in to manage your properties & profile.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <input type="email" required placeholder="Email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          <input type="password" required placeholder="Password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          {err && <p className="text-red-500 text-sm" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit-btn"
            className="w-full py-3 font-semibold text-white bg-gradient-to-r from-brand-500 to-brand-600 rounded-xl hover:shadow-soft transition-all active:scale-95 disabled:opacity-60">
            {loading ? "Logging in…" : "Log In"}
          </button>
        </form>

        <p className="text-neutral-500 text-sm mt-6 text-center">
          New here? <Link to="/register" className="text-brand-600 hover:underline font-medium" data-testid="link-register">Create an account</Link>
        </p>
      </motion.div>
    </main>
  );
}
